// src/Contact.js
import React from 'react';

const Contact = () => {
  return <h2>Get in touch with us on the Contact Page!</h2>;
};

export default Contact;
